"use client";
import { SEC_ASSESSMENT_FEATURES } from "./constants";
import CardsList from "@/components/cardsList";

const SecAssessmentFeatures = () => {
  return (
    <CardsList
      list={SEC_ASSESSMENT_FEATURES.list}
      title={SEC_ASSESSMENT_FEATURES.title}
      hoverEffect
      hover={{
        transform: "scale(1.04) rotate(0.3deg)",
        boxShadow: "0 12px 28px rgba(0, 0, 0, 0.3), 0 0 16px rgba(0, 191, 255, 0.4)",
        transition: "all 0.3s ease-in-out",
      }}
    />
  );
};

export default SecAssessmentFeatures;
